import camelcaseKeys from 'camelcase-keys'

export default function reducer(
  state = {
    facility: { name: 'Loading', sitesDetails: { loops: {} } },
    facilitySnakecase: { name: 'Loading', sites_details: { loops: {} } },
    facilities: [],
    filter: { agency: null },
    facilityLookup: '',
    search: true,
    query: '',
    fetching: false,
    fetched: false,
    error: null
  },
  action
) {
  switch (action.type) {
    case 'FETCH_FACILITY': {
      return { ...state, fetching: true, fetched: false, error: null }
    }
    case 'FETCH_FACILITY_REJECTED': {
      return { ...state, fetching: false, error: action.payload }
    }
    case 'FETCH_FACILITY_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        facility: camelcaseKeys(action.payload, { deep: true }),
        facilitySnakecase: action.payload,
        error: null
      }
    }
    case 'FETCH_AR_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        facility: camelcaseKeys(action.payload.facility, { deep: true }),
        facilitySnakecase: action.payload.facility,
        error: null
      }
    }
    case 'FETCH_FACILITIES': {
      return { ...state, fetching: true }
    }
    case 'FETCH_FACILITIES_REJECTED': {
      return { ...state, fetching: false, error: action.payload }
    }
    case 'FETCH_FACILITIES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        facilities: action.payload,
        error: null
      }
    }
    case 'SET_FACILITY_LOOKUP': {
      return {
        ...state,
        search: false,
        facilityLookup: action.payload
      }
    }
    case 'SET_FACILITY_FILTER': {
      return {
        ...state,
        search: false,
        filter: action.payload
      }
    }
    case 'FACILITIES_QUERY': {
      return {
        ...state,
        query: action.payload
      }
    }
    default: {
      return state
    }
  }
}
